import React from "react"

const CustomLoader = ({ text, className }) => {
    return (
        <div className={`custom-loader ${className ? className : ""}`}>
            <div className="loader"></div>
            <p className="loading-text">{text}</p>
        </div>
    )
}

export default CustomLoader
